export const createInput = (className, type, text = ``) => {
  const input = document.createElement(`input`);
  input.className = className;
  input.type = type;
  input.value = text;

  return input;
};
